/**
 * To avoid using moment.js library for bundle size concern, please use this class
 * for any time related manipulation.
 * API doc: https://wiki.jcpenney.com/display/DIGPLAT/MYODACORE-502+Remove+moment.js+everywhere
 * Please extend this class based on your needs
 */
const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

/* istanbul ignore next */
const toTimeString = (input) => {
    const tzo = -input.getTimezoneOffset();
    const dif = tzo >= 0 ? '+' : '-';
    const pad = function (num) {
        const norm = Math.floor(Math.abs(num));
        return (norm < 10 ? '0' : '') + norm;
    };
    return `${input.getFullYear()}-${pad(input.getMonth() + 1)}-${pad(input.getDate())}T${pad(
        input.getHours()
    )}:${pad(input.getMinutes())}:${pad(input.getSeconds())}${dif}${pad(tzo / 60)}:${pad(
        tzo % 60
    )}`;
};

/* istanbul ignore next */
const pruneTimeString = (input) => {
    if (typeof input === 'string' && input.includes('-') && input.length === 10) {
        const a = input.split('-');
        return `${a[1]}/${a[2]}/${a[0]}`;
    }
    return input;
};

/* istanbul ignore next */
const time = (input, givenFormat) => ({
    t: (function () {
        if (!input) return new Date();
        let t = new Date(pruneTimeString(input));
        if (givenFormat) {
            const year = [];
            const month = [];
            const day = [];
            const hour = [];
            const minute = [];
            let apm = '';
            for (let i = 0; i < givenFormat.length; i++) {
                switch (givenFormat[i]) {
                    case 'Y':
                        year.push(input[i]);
                        break;
                    case 'M':
                        month.push(input[i]);
                        break;
                    case 'D':
                        day.push(input[i]);
                        break;
                    case 'H':
                        hour.push(input[i]);
                        break;
                    case 'm':
                        minute.push(input[i]);
                        break;
                    case 'A':
                        apm = input.slice(input.length - 2);
                }
            }
            t = new Date(
                `${month.join('')}/${day.join('')}/${year.join('')} ${hour.join('')}:${minute.join(
                    ''
                )} ${apm}`
            );
        }
        return t;
    })(),

    isValid() {
        return !!this.t.getTime();
    },

    add(num, unit) {
        num = parseInt(num);
        switch (unit) {
            case 'months':
                const targetMonthDays = new Date(
                    this.t.getFullYear(),
                    this.t.getMonth() + 1 + num,
                    0
                ).getDate();
                if (this.t.getDate() > targetMonthDays) {
                    this.t.setDate(targetMonthDays);
                }
                this.t.setMonth(this.t.getMonth() + num);
                return this;

            case 'days':
            case 'day':
                this.t.setDate(this.t.getDate() + num);
                return this;

            case 'minutes':
            case 'm':
                this.t.setMinutes(this.t.getMinutes() + num);
                return this;

            case 'seconds':
            case 's':
                this.t.setSeconds(this.t.getSeconds() + num);
                return this;

            default:
                return this;
        }
    },

    diff(input2 = {}, unit) {
        if (!input2.t && typeof input2 !== 'string') return 0;
        const timeObject = input2.t ? input2.t : new Date(input2);
        switch (unit) {
            case 'seconds':
                return parseInt(this.t.getTime() / 1000) - parseInt(timeObject.getTime() / 1000);
            default:
                return parseInt(this.t.getTime()) - parseInt(timeObject.getTime());
        }
    },

    isAfter(timeObject = {}) {
        return timeObject.t ? this.t.getTime() - timeObject.t.getTime() > 0 : false;
    },

    subtract(num, unit) {
        return this.add(-num, unit);
    },

    format(resultFormat) {
        if (!resultFormat) return toTimeString(this.t);

        let month = this.t.getMonth() + 1;
        let day = this.t.getDate();
        const year = this.t.getFullYear();
        let hour = this.t.getHours();
        let minute = this.t.getMinutes();

        const dateFormat = resultFormat.split('').filter((l) => l === 'D').length;

        let result = resultFormat;
        result = result.replace('YYYY', year);
        result = result.replace('YY', year.toString().slice(2));

        if (dateFormat === 1) {
            result = result.replace('D', day);
        }

        const getMonthName = monthNames[month - 1] || '';

        result = result.replace('MMMM', getMonthName);
        result = result.replace('MMM', getMonthName.slice(0, 3));
        result = result.replace('LL', `${getMonthName} ${day}, ${year}`);

        if (month.toString().length < 2) month = `0${month}`;
        result = result.replace('MM', month);

        if (dateFormat === 2) {
            if (day.toString().length < 2) day = `0${day}`;
            result = result.replace('DD', day);
        }

        if (hour.toString().length < 2) hour = `0${hour}`;
        result = result.replace('HH', hour);
        if (minute.toString().length < 2) minute = `0${minute}`;
        result = result.replace('mm', minute);

        return result;
    },
});

time.duration = (millisec) => ({
    asHours() {
        return millisec / 3600000;
    },
    minutes() {
        return parseInt(millisec / 60000) % 60;
    },
    seconds() {
        return parseInt(millisec / 1000) % 60;
    },
});

// TODO
// time.parseZone = (input) => {
// const offset = input.split('+')[1];
// const date = new Date(input);
// const localOffset = date.getTimezoneOffset();
// return time(input);
// }

export default time;
